import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import HitListItems from './HitListItems';
import { GLOBAL_SEARCH_ITEMS } from '../../../types/GlobalSearch';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        list: (_a = {
                backgroundColor: theme.palette.background.paper,
                overflowY: 'auto',
                display: 'flex'
            },
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
            },
            _a[theme.breakpoints.up('sm')] = {
                width: '350px',
            },
            _a['& li,ul'] = {
                margin: 0,
                padding: 0,
                width: '100%',
                listStyleType: 'none',
            },
            _a),
    });
});
var HitList = function (_a) {
    var setSelectHit = _a.setSelectHit, selectedHit = _a.selectedHit, results = _a.results;
    var classes = useStyles();
    var t = useTranslation().t;
    var fleetOrders = get(results, GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM, []);
    var urbanOrders = get(results, GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM, []);
    var contacts = get(results, GLOBAL_SEARCH_ITEMS.CONTACT_ITEM, []);
    var mechanical = get(results, GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM, []);
    var onCallCases = get(results, GLOBAL_SEARCH_ITEMS.ONCALL_ITEM, []);
    return (React.createElement("div", { className: "".concat(classes.list) },
        React.createElement("ul", { style: {} },
            React.createElement(HitListItems, { items: fleetOrders, itemsType: GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM, title: t('Fleet Order'), selectedHit: selectedHit, setSelectHit: setSelectHit }),
            React.createElement(HitListItems, { items: urbanOrders, itemsType: GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM, title: t('Urban Order'), selectedHit: selectedHit, setSelectHit: setSelectHit }),
            React.createElement(HitListItems, { items: contacts, itemsType: GLOBAL_SEARCH_ITEMS.CONTACT_ITEM, title: t('Contacts'), selectedHit: selectedHit, setSelectHit: setSelectHit }),
            React.createElement(HitListItems, { items: mechanical, itemsType: GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM, title: t('Mechanical'), selectedHit: selectedHit, setSelectHit: setSelectHit }),
            React.createElement(HitListItems, { items: onCallCases, itemsType: GLOBAL_SEARCH_ITEMS.ONCALL_ITEM, title: t('ONCall'), selectedHit: selectedHit, setSelectHit: setSelectHit }))));
};
export default HitList;
//# sourceMappingURL=HitList.js.map